<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation>
			<h4 v-if="!onlySample && mode != 'edit'">عنوان قالب: {{ localData.title }}</h4>
			<v-text-field v-else-if="!onlySample" :disabled="mode != 'edit'" ref="title" v-model="localData.title" class="" label="عنوان قالب*" :error-messages="errorMessages" :rules="[() => !!localData.title || 'عنوان قالب را وارد کنید']" required />
			<h4 class="mt-1 mb-4" v-if="!onlySample && mode != 'edit' || category >= 0">دسته: {{ localData.category ? localData.category.title : 'نامشخص' }}</h4>
			<v-combobox v-else-if="!onlySample" v-model="localData.category" required :items="categories" label="دسته قالب" single-line :error-messages="errorMessages" item-text="title" item-value="id" />

			<div v-if="mode === 'edit' && !onlySample">
				<ul class="pattern-tags">
					<li v-for="tag in patternTags" :key="tag" @click="appendTag(tag)">{{ tag }}</li>
				</ul>
			</div>
			<div v-if="!onlySample" class="mt-2">
				<v-textarea v-model="localData.pattern" @change="() => { if (localData.smsPatternPanel === 4) prepareIPPanelKeys() }" ref="pattern" :disabled="mode != 'edit'" outlined :error-messages="errorMessages" label="الگوی قالب*" hint="قالب پیامک پس از تایید توسط مدیر قابل استفاده می باشد." :rules="[() => !!localData.pattern || 'قالب را وارد کنید']" required />
			</div>

			<div style="font-size: 0.8rem;" class="mb-2" v-if="!onlySample || (onlySample && localData.pattern)">
				<div>نمونه پیامک:</div>
				<div v-html="sampleText" style="white-space: pre-line;">

				</div>
			</div>
			<div v-if="!onlySample" class="mt-2 grey lighten-2 pa-2">
				<v-checkbox class="mb-0" :disabled="mode != 'edit'" color="secondary" v-model="localData.isPatternBase" :label="'جهت استفاده در کدهای پترنی؟'" />
				<div class="d-flex" style="column-gap: 10px;">
					<v-select class="pt-0 mt-0" :disabled="mode != 'edit'" v-model="localData.smsPatternPanel" v-show="localData.isPatternBase" :items="smsPanels" label="انتخاب پنل پیامک" clearable required item-text="title" item-value="value" @change="(val) => { if (val === 4) prepareIPPanelKeys() }"></v-select>
					<v-text-field class="pt-0 mt-0" :disabled="mode != 'edit'" v-model="localData.patternBaseCode" v-show="localData.isPatternBase" label="کد/نام پترن" />
				</div>
				<div v-if="localData.smsPatternPanel === 4 && ippanelKeys && mode === 'edit'">
					<small>متغیرهای پیامک را مطابق با کلیدهای ippanel معادل سازی کنید: </small>
					<div v-for="(key, index) in ippanelKeys" :key="key.tag + String(index)" class="mb-2">
						<div><small>{{ key.tag }}:</small></div>
						<input type="text" v-model="key.key" class="my-input ltr" />
					</div>
				</div>
			</div>
			<div class="status" v-if="!onlySample">
				<v-row>
					<v-col cols="6">
						<div><span :style="{ 'color': statusColor }">وضعیت: {{ status }}</span></div>
						<a href="#" @click="rejectReasonDialog = true" v-if="this.localData.status === 2 && this.localData.rejectReason">مشاهده دلیل رد</a>
					</v-col>
					<v-col cols="6" class="align-end text-left">
						<v-btn :disabled="localData.isSystem" @click="update" v-if="mode !== 'edit' && !localData.isSystem" color="green" small dark>
							ویرایش
						</v-btn>
						<v-btn class="mx-1" @click="cancel" v-if="mode === 'edit' && !alwaysEdit" color="grey" small dark>
							انصراف
						</v-btn>
						<v-btn :loading="submitLoading" @click="save()" v-if="mode === 'edit' && !localData.isSystem" color="blue" small dark>
							ذخیره
						</v-btn>
						<v-btn v-if="!alwaysEdit && mode !== 'edit' && !localData.isSystem" class="mx-1" color="pink" @click="$emit('remove', localData.id)" dark small>
							حذف
						</v-btn>
						<!-- <a href="#" class="mx-1" v-if="mode !== 'edit' && !localData.isSystem" @click="mode='edit'">ویرایش</a>
					<a href="#" class="mx-1" v-if="mode === 'edit' && !localData.isSystem" @click="save()">ذخیره</a>
					<a href="#" class="mx-1" v-if="mode === 'edit' && !alwaysEdit" @click="mode='view'">انصراف</a> -->
						<!-- <v-btn class="" fab dark small color="pink" @click="remove()">
						<v-icon dark>
							mdi-trash-can-outline
						</v-icon>
					</v-btn> -->
					</v-col>
				</v-row>
			</div>
		</v-form>

		<v-dialog v-model="rejectReasonDialog" persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">دلیل رد قالب پیامک</span></div>
					<v-spacer />
					<v-btn @click="rejectReasonDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<p>{{ localData.rejectReason }}</p>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import { emptyId } from '@/util/emptyId'
import api from '@/util/app-api'
import toast from '@/util/toast'
import { smsReplacePattern, smsCategories } from '@/util/enums'
import { cloneDeep } from 'lodash'

export default {
	name: 'SmsPattern',
	props: {
		category: { type: Number, default: -1 },
		group: String,
		pattern: String,
		alwaysEdit: Boolean,
		onlySample: Boolean,
		data: Object
	},
	emits: ['remove', 'update', 'insert'],
	data() {
		return {
			ippanelKeys: [],
			rejectReasonDialog: false,
			errorMessages: '',
			mode: 'view',
			submitLoading: false,
			localData: { pattern: '', category: null },
			originalData: {},
			replace: smsReplacePattern,
			smsPanels: [
				{ value: 2, title: 'ملی پیامک' },
				{ value: 3, title: 'کاوه نگار' },
				{ value: 4, title: 'IPPanel' },
			],
			categories: smsCategories,

		}
	},
	computed: {
		patternTags() {
			if (this.localData.category?.value === 1) // وضعیت درخواست
				return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ هر قسط}', '{مبلغ درخواستی}', '{تعداد قسط}', '{تاریخ درخواست}', '{نوع وام}', '{شماره درخواست}', '{تاریخ تغییر وضعیت}', '{نام نماینده}', '{وضعیت جدید}', '{وضعیت جدید نماینده}', '{سررسید واریز نماینده}', '{توسط نماینده با لیبل}']

			if (this.localData.category?.value === 2 || this.localData.category?.value === 3) // ورود - ثبت نام
				return ['{نام و نام خانوادگی}', '{نام کاربری}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}', '{نام فروشگاه}', '{نام تجاری نماینده}']

			if (this.localData.category?.value === 4) // کد تائیدیه ثبت نام
				return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}', '{نام فروشگاه}']

			if (this.localData.category?.value === 5) // شارژ کیف پول
				return ['{نام مشتری}', '{نام فروشگاه}', '{لینک پرداخت}', '{بخش متغیر لینک پرداخت}', '{تاریخ}']

			if (this.localData.category?.value === 6) // ثبت سفارش جدید
				return ['{نام مشتری}', '{نام فروشگاه}', '{کد ملی}', '{تاریخ}', '{کالای مورد درخواست}']

			if (this.localData.category?.value === 7) // ثبت پرونده
				return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ هر قسط}', '{شماره وام}', '{نوع وام}', '{تاریخ شروع}', '{مبلغ وام}', '{بازپرداخت با بهره}', '{تعداد اقساط}', '{مبلغ باقیمانده}', '{نام تجاری نماینده}']

			if (this.localData.category?.value === 8) // برداشت از کیف پول
				return ['{نام مشتری}', '{نام تجاری نماینده}', '{مبلغ}', '{تاریخ}', '{مانده اعتبار کیف پول}', '{کد تائیدیه}', '{کد رهگیری}']

			if (this.localData.category?.value === 9) // لینک واریز صورتحساب
				return ['{نام مشتری}', '{نام تجاری نماینده}', '{لینک پرداخت}', '{تاریخ}', '{مبلغ صورتحساب}', '{شماره سیستمی صورتحساب}']

			if (this.localData.category?.value === 10) // لینک_قرارداد
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{لینک قرارداد}', '{بخش متغیر لینک قرارداد}']

			if (this.localData.category?.value === 11) // کد_تائیدیه_قرارداد
				return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}']

			if (this.localData.category?.value === 12) // اطلاعیه_تکمیل_قرارداد
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}']

			if (this.localData.category?.value === 13) // لینک_قرارداد ضامن
				return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{نام و نام خانوادگی ضامن}', '{کد ملی ضامن}', '{موبایل ضامن}']

			if (this.localData.category?.value === 14) // کد_تائیدیه_قرارداد ضامن
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{لینک قرارداد}', '{بخش متغیر لینک قرارداد}', '{نام و نام خانوادگی ضامن}', '{کد ملی ضامن}', '{موبایل ضامن}']

			if (this.localData.category?.value === 15) // اطلاعیه_تکمیل_قرارداد ضامن
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{نام و نام خانوادگی ضامن}', '{کد ملی ضامن}', '{موبایل ضامن}']

			if (this.localData.category?.value === 16) //اطلاعیه_ثبت_وام_جدید
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام تجاری نماینده}', '{نوع وام}', '{شماره درخواست}', '{تاریخ و ساعت درخواست}', '{مبلغ درخواستی}', '{تعداد قسط}', '{وضعیت درخواست}']

			return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ قسط}', '{مبلغ مانده قسط}', '{شماره قسط}', '{مبلغ واریز}', '{مبلغ آخرین واریز}', '{تاریخ واریز}', '{مانده وام}', '{لینک پرداخت}', '{بخش متغیر لینک پرداخت}', '{شماره پیگیری تراکنش}', '{نام تجاری نماینده}']
		},
		sampleText() {
			return this.convertPatternToSample(this.localData?.pattern)
		},
		status() {
			switch (this.localData.status) {
				case 0:
					return 'در انتظار بررسی'
				case 1:
					return 'تایید شده'
				case 2:
					return 'رد شده'
				default:
					return '-'
			}
		},
		statusColor() {
			switch (this.localData.status) {
				case 0:
					return 'orange'
				case 1:
					return 'green'
				case 2:
					return 'red'
				default:
					return 'grey'
			}
		}
	},
	created() {
		this.mode = this.alwaysEdit ? 'edit' : 'view'
		if (this.data) {
			this.localData = _.cloneDeep(this.data)
			this.localData.category = this.categories.find(x => x.value === (this.localData.category?.value || this.localData.category))
		}
		else if (this.alwaysEdit)
			this.makeLocalDataEmpty()
	},
	watch: {
		data: {
			deep: true,
			immediate: true,
			handler(val) {
				this.localData = val || { pattern: '', category: null }
				this.localData.category = this.categories.find(x => x.value === (this.localData?.category?.value || this.localData?.category))
				if (this.localData.smsPatternPanel === 4)
					this.ippanelKeys = this.localData.ippanelKeysJson ? JSON.parse(this.localData.ippanelKeysJson) : []
			}
		}
	},
	methods: {
		makeLocalDataEmpty() {
			this.localData = { id: emptyId, pattern: '', category: null }
			if (this.category >= 0) {
				this.localData.category = this.categories.find(x => x.value === this.category)
			}
		},
		convertPatternToSample(pattern) {
			const replaceAll = (str, find, replace) => {
				return str.toString().replace(new RegExp(find, 'g'), replace)
			}
			if (!pattern)
				return ''
			for (var tag of this.patternTags) {
				pattern = replaceAll(pattern, tag, this.replace[tag])
			}
			return pattern
		},
		save() {
			if (!this.$refs.form.validate()) { return }
			this.submitLoading = true
			let data = {}
			Object.assign(data, this.localData)
			data.category = this.localData.category.value
			data.ippanelKeysJson = this.ippanelKeys ? JSON.stringify(this.ippanelKeys) : null
			api.post('admin/smsPattern/' + (this.localData.id === emptyId ? 'create' : 'edit'), data)
				.then(
					response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						if (this.localData.id === emptyId) {
							this.$emit('insert', response)
							this.makeLocalDataEmpty()
						}
						else {
							this.$emit('update', response)
						}
						this.mode = this.alwaysEdit ? 'edit' : 'view'
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.submitLoading = false })
		},
		appendTag(tag) {
			const insertAtCursor = (myField, myValue) => {
				//IE support
				if (document.selection) {
					myField.focus()
					sel = document.selection.createRange()
					sel.text = myValue
				}
				//MOZILLA and others
				else if (myField.selectionStart || myField.selectionStart == '0') {
					var startPos = myField.selectionStart
					var endPos = myField.selectionEnd
					var val = myField.value.substring(0, startPos)
						+ myValue
						+ myField.value.substring(endPos, myField.value.length)
					return val
					// myField.value = val
				} else {
					return myField.value + myValue
					// myField.value += myValue
				}
			}
			var textarea = this.$refs.pattern.$el?.querySelector('textarea')
			if (textarea) {
				this.localData.pattern = insertAtCursor(textarea, tag)
				textarea.focus()
			}
		},
		update() {
			this.mode = 'edit'
			this.originalData = { ...this.localData }
		},
		cancel() {
			this.mode = 'view'
			this.localData = { ...this.originalData }
		},
		prepareIPPanelKeys() {
			if (!this.ippanelKeys)
				this.ippanelKeys = []
			const tags = this.localData.pattern?.match(/\{[^}]+\}/g) || []
			for (let tag of tags) {
				if (this.ippanelKeys.findIndex(x => x.tag === tag) === -1)
					this.ippanelKeys.push({ tag: tag, key: '' })
			}
			for (let index = 0; index < this.ippanelKeys.length; index++) {
				if (tags.indexOf(this.ippanelKeys[index].tag) === -1)
					this.ippanelKeys.splice(index, 1)
			}
		}
	}
}
</script>
<style scoped>
.pattern-tags {
	list-style: none;
}

.pattern-tags li {
	display: inline;
	margin: 3px;
	color: blueviolet;
	cursor: pointer;
}

.status {
	border-top: 1px dashed #9e9e9e;
	padding: 10px;
}
</style>
